/**
 * Format the text area content and set br tags for new lines
 *
 * @param content
 */
export default function formatTextAreaContent (content: string) {
  return content.replace(/(?:\r\n|\r|\n)/g, '<br>');
}
